module.exports = __webpack_public_path__ + "static/media/email2.6917bffa.png";